import Sector from '../../Constants/Sector.json';
import LegacySectors from '../../Constants/Sector.legacy.json';

export function getSectorNames(sectors) {
    return sectors?.length? (sectors.split(",").map(sectorId => {
            let sector = Sector.find(s => s.value === Number(sectorId));
            if (sector?.label) return sector.label;
            sector = LegacySectors.find(s => s.value === Number(sectorId));
            if (sector?.label) return sector.label;
            return false
        }).filter(sector => sector).join(", ")): "";
}

